import React from 'react'
import { css } from '@emotion/react'
import CardBase from './Base'

const containerCss = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
`

const topPartCss = css`
  display: flex;
  margin-bottom: 10px;
`

const itemLogoWrapperCss = (theme) => css`
  width: 56px;
  height: 56px;
  background-color: ${theme.colors.primaryAlpha(0.15)};
  border-radius: 6px;
  padding: 11px 0;
  margin-right: 20px;
`

const itemInfoCss = css`
  display: flex;
  flex-direction: column;
`

const itemNameCss = css`
  margin: 0px 20px 4px 0;
`

const nameBox1Css = (theme) => css`
  background-color: ${theme.colors.primaryAlpha(0.15)};
  width: 84px;
  height: 10px;
  border-radius: 14px;
  margin-bottom: 7px;
`

const nameBox2Css = (theme) => css`
  background-color: ${theme.colors.primaryAlpha(0.15)};
  width: 42px;
  height: 10px;
  border-radius: 14px;
`

const descriptionBox1Css = (theme) => css`
  background-color: ${theme.colors.primaryAlpha(0.15)};
  width: 100%;
  height: 10px;
  border-radius: 14px;
  margin-bottom: 7px;
`

const descriptionBox2Css = (theme) => css`
  background-color: ${theme.colors.primaryAlpha(0.15)};
  width: 60%;
  height: 10px;
  border-radius: 14px;
`

const ProductCardSkeleton = () => {
  return (
    <CardBase>
      <div css={containerCss}>
        <div css={topPartCss}>
          <div css={itemLogoWrapperCss} />
          <div css={itemInfoCss}>
            <div css={itemNameCss}>
              <div css={nameBox1Css} />
              <div css={nameBox2Css} />
            </div>
          </div>
        </div>
        <div css={descriptionBox1Css} />
        <div css={descriptionBox2Css} />
      </div>
    </CardBase>
  )
}

export default ProductCardSkeleton
